import React from "react";
import "./MyClients.css";
import SectionHeading3 from "../SectionHeadings/Heading3/SectionHeading3";
import {
  brandDebookApp,
  brandDinkIcon,
  brandDraftInc,
  brandFeedly,
  brandImgur,
  brandRejouice,
  brandSundownStudio,
  brandYamaha,
} from "../../assets/images";

const MyClients = () => {
  return (
    <section className="client-section section">
      <div className="container">
        <SectionHeading3
          title="Brands I’ve Collaborated With"
          description="Over the years, I’ve had the privilege of working with a diverse range of brands—helping bring their ideas to life through thoughtful design and development."
        />
        <div className="client-area-container">
          <div className="client-brand-wrapper">
            <div className="client-brand-wrap">
              <div className="client-brand-item">
                <div className="client-brand-thumb">
                  <img src={brandDraftInc} alt="client-img" />
                </div>
              </div>
              <div className="client-brand-item">
                <div className="client-brand-thumb">
                  <img src={brandDebookApp} alt="client-img" />
                </div>
              </div>
              <div className="client-brand-item">
                <div className="client-brand-thumb">
                  <img src={brandYamaha} alt="client-img" />
                </div>
              </div>
            </div>
            <div className="client-brand-wrap">
              <div className="client-brand-item">
                <div className="client-brand-thumb">
                  <img src={brandImgur} alt="client-img" />
                </div>
              </div>
              <div className="client-brand-item">
                <div className="client-brand-thumb">
                  <img src={brandFeedly} alt="client-img" />
                </div>
              </div>
              <div className="client-brand-item">
                <div className="client-brand-thumb">
                  <img src={brandDinkIcon} alt="client-img" />
                </div>
              </div>
            </div>
            <div className="client-brand-wrap">
              <div className="client-brand-item">
                <div className="client-brand-thumb">
                  <img src={brandSundownStudio} alt="client-img" />
                </div>
              </div>
              <div className="client-brand-item">
                <div className="client-brand-thumb">
                  <img src={brandRejouice} alt="client-img" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MyClients;
